/* =============================================================================
 * Mi Amante advertorial runtime
 *
 * ONE job: measure the page. ViewContent with real ids, scroll depth, CTA clicks.
 *
 * It used to do two more and both were removed on 2026-08-19:
 *   - it appended its OWN sticky buy bar carrying the product PRICE. That
 *     duplicated the page's sticky CTA, put a price on a listicle (which this
 *     format does not do, prices are the PDP's job), and had been rendering
 *     unstyled since the v4 CSS rewrite dropped its rules. The store footer was
 *     hiding it; removing that footer exposed it at the bottom of the page.
 *   - it decorated internal links with utm and click ids. The in-page
 *     attribution script now owns that and does strictly more.
 *
 * TRACKING ARCHITECTURE
 * This storefront runs Meta through Shopify's Web Pixels Manager. Every event is
 * therefore published three ways: Shopify.analytics.publish() (the supported way
 * to emit a custom event a Web Pixel can subscribe to), window.dataLayer for any
 * GTM consumer, and a guarded window.fbq() call.
 *
 * MEASURED ON THE LIVE PAGE 2026-08-12, do not assume otherwise:
 *   - window.fbq IS a function in page scope (an earlier reading of the PDP HTML
 *     said it was not; that was wrong, it is injected at runtime).
 *   - view_content, scroll_depth 25/50/75/100 and cta_click all fire and all
 *     reach dataLayer with the real product id.
 *   - ZERO facebook.com/tr beacons were observed leaving the page.
 *
 * >> So these events are NOT in Ads Manager yet. Getting them there needs a
 * >> Custom Pixel created in Shopify admin subscribing to these event names.
 * >> That is an admin config step, not a theme change. See theme/README.md.
 * ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.adv-root');
  if (!root) return;

  var handle = root.getAttribute('data-adv-product-handle') || '';
  var name = root.getAttribute('data-adv-name') || document.title;
  var product = null;

  /* ---------- event bus ---------------------------------------------------- */
  function emit(event, payload) {
    payload = payload || {};
    payload.advertorial = window.location.pathname;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(event, payload);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'advertorial_' + event }, payload));
    } catch (e) {}
    /* only fires if a theme-level pixel is ever added; a no-op under Web Pixels */
    try {
      if (typeof window.fbq === 'function') {
        if (event === 'view_content') {
          window.fbq('track', 'ViewContent', {
            content_ids: payload.content_ids,
            content_type: 'product',
            value: payload.value,
            currency: payload.currency
          });
        } else {
          window.fbq('trackCustom', 'Advertorial' + event, payload);
        }
      }
    } catch (e) {}
  }

  /* ---------- 1. ViewContent with real ids --------------------------------- */
  /* ids and price come from the storefront product JSON, so each market reports
     its own variant ids and its own currency rather than a hardcoded GBP value */
  if (handle) {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        product = p;
        emit('view_content', {
          content_ids: [String(p.id)],
          content_variant_ids: (p.variants || []).slice(0, 50).map(function (v) { return String(v.id); }),
          content_name: p.title,
          content_type: 'product',
          value: (p.price || 0) / 100,
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
        });
      })
      .catch(function () {});
  }

  /* ---------- 2. scroll depth 25 / 50 / 75 / 100 --------------------------- */
  var marks = [25, 50, 75, 100];
  var fired = {};
  var ticking = false;

  function checkDepth() {
    ticking = false;
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    var pct = ((window.pageYOffset || doc.scrollTop) / scrollable) * 100;
    for (var i = 0; i < marks.length; i++) {
      var m = marks[i];
      if (pct >= m && !fired[m]) {
        fired[m] = true;
        emit('scroll_depth', { depth: m });
      }
    }
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(checkDepth); }
  }, { passive: true });
  checkDepth();

  /* ---------- 3. link tagging: NOT here -----------------------------------
     This file used to decorate every internal link with the landing utm and
     click ids. The in-page attribution script now owns that and does strictly
     more: it stamps the visit into localStorage for 30 days so the storefront
     can attribute the ORDER, fills in utm defaults, and adds ma_lp/ma_v. Two
     scripts appending params to the same href is how you get duplicates, so
     this one stands down. */

  /* ---------- 4. CTA clicks ------------------------------------------------ */
  var ctas = document.querySelectorAll('a.cta, a[href*="/products/"], a[href*="/cart"]');
  Array.prototype.forEach.call(ctas, function (a) {
    a.addEventListener('click', function () {
      var href = a.getAttribute('href') || '';
      emit('cta_click', {
        cta_text: (a.textContent || '').trim().slice(0, 60),
        cta_href: href,
        cta_style: a.className.indexOf('cta-solid') > -1 ? 'solid'
                 : a.className.indexOf('cta-ghost') > -1 ? 'ghost' : 'inline',
        cta_position: Math.round(a.getBoundingClientRect().top + window.pageYOffset),
        is_exit: href.indexOf('/products/') > -1 || href.indexOf('/cart') > -1
      });
    }, { passive: true });
  });

})();
